import { mockBaseQuery } from '@gv/triage-components';

import { mockApiHandlers } from '../api/mock/config';
import { citiesApiHandlers } from '../api/cities/config';
import { appointmentApiHandlers } from '../api/appointments/config';

export const mockApiQuery = mockBaseQuery({
  handlers: mockApiHandlers,
});

export const appointmentApiQuery = mockBaseQuery({
  handlers: appointmentApiHandlers,
});

export const citiesApiQuery = mockBaseQuery({ handlers: citiesApiHandlers });
